module.exports = __webpack_public_path__ + "img/44.8ac29511.jpg";